import React from 'react';
import ServiceTile from '@/ui/service-tile/service-tile';
import {CategoryDetails, SubCategory} from '@/types';

type ServiceCategoriesProps = {
    service: CategoryDetails;
};

const ServiceTiles: React.FC<ServiceCategoriesProps> = ({service}: ServiceCategoriesProps) => {

    return (
        <div className="mb-20 flex flex-wrap justify-center gap-2 md:mx-auto"
        >
            {service?.subCategories?.map((service: SubCategory) => (
                <div
                    key={service.id}
                    sx={{py: 2}}
                >
                    <ServiceTile service={service} height='150px' fadeIn />
                </div>
            ))}
        </div>
    );
};

export default ServiceTiles;
